document.addEventListener('DOMContentLoaded', function() {
  // Testimonial Slider functionality - not needed for listicle-articles but keeping for future use
  const testimonialSliders = document.querySelectorAll('.testimonial-slider');
  
  testimonialSliders.forEach(function(slider) {
    const slides = slider.querySelectorAll('.testimonial-slide');
    const dots = slider.querySelectorAll('.testimonial-dot');
    const prevBtn = slider.querySelector('.testimonial-nav--prev');
    const nextBtn = slider.querySelector('.testimonial-nav--next');
    
    let currentSlide = 0;
    const totalSlides = slides.length;
    
    if (totalSlides <= 1) return; // No need for slider if only one slide
    
    // Function to show slide
    function showSlide(index) {
      // Hide all slides
      slides.forEach(slide => {
        slide.classList.remove('active');
      });
      
      // Remove active class from all dots
      dots.forEach(dot => {
        dot.classList.remove('active');
      });
      
      // Show current slide
      if (slides[index]) {
        slides[index].classList.add('active');
      }
      
      // Activate current dot
      if (dots[index]) {
        dots[index].classList.add('active');
      }
      
      currentSlide = index;
    }
    
    // Function to go to next slide
    function nextSlide() {
      const next = (currentSlide + 1) % totalSlides;
      showSlide(next);
    }
    
    // Function to go to previous slide
    function prevSlide() {
      const prev = (currentSlide - 1 + totalSlides) % totalSlides;
      showSlide(prev);
    }
    
    // Event listeners for navigation arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', prevSlide);
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', nextSlide);
    }
    
    // Event listeners for dots
    dots.forEach(function(dot, index) {
      dot.addEventListener('click', function() {
        showSlide(index);
      });
    });
    
    // Auto-advance slides every 5 seconds (optional)
    if (totalSlides > 1) {
      setInterval(nextSlide, 5000);
    }
    
    // Initialize first slide
    showSlide(0);
  });
});
